var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 12,
  fill: "current"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16.98.293a1 1 0 0 1 0 1.414l-10 10a1 1 0 0 1-1.415 0L1.019 7.162a1 1 0 1 1 1.415-1.415l3.838 3.839L15.565.293a1 1 0 0 1 1.414 0",
  clipRule: "evenodd"
})));
export { SvgCheck as ReactComponent };
export default __webpack_public_path__ + "static/media/check.98c317c7.svg";